import {
    ChangeDetectionStrategy,
    Component,
    forwardRef,
    inject
} from '@angular/core';
import {
    FormsModule,
    ReactiveFormsModule,
    NG_VALUE_ACCESSOR,
    NG_VALIDATORS,
    ControlContainer,
    FormGroupDirective
} from '@angular/forms';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { InvoiceOptions } from '../../entities/invoice-card.options';
import { LoaderService } from '@shared/services/loader.service';
import { catchError, concat, concatMap, finalize, of, timer } from 'rxjs';
import { PostInvoicesToAADESchema } from '@shared/zigra-schemas/custom/post-invocies-to-aade.schema.service';
import {
    InvoiceTypeQuery,
    ProviderResponseTypeQuery,
    ResponseTypeErrorTypeQuery,
    ProviderResponseErrorTypeQuery,
    InvoiceType,
    POSTerminalGraphQLSchemaStateToken,
    POSTerminalGraphQLSchema,
    POSTerminalTypeQuery,
    POSTerminal,
    InvoicePaymentGraphQLSchema,
    POSTerminalGraphQLSchemaActions,
    POSTerminalGraphQLSchemaSelectors,
    InvoicePaymentGraphQLSchemaActions,
    InvoicePaymentTypeFormGroup,
    InvoicePaymentTypeQuery,
    InvoicePaymentType,
    InvoicePaymentGraphQLSchemaSelectors,
    ProviderSignatureTypeQuery,
    ProviderSignatureMoreDataTypeQuery
} from '@shared/zigra-schemas/zigra-schema.autogenerated.models';
import { Store } from '@ngxs/store';
import { HttpClient } from '@angular/common/http';
import { v4 as uuidv4 } from 'uuid';
import { ButtonModule } from 'primeng/button';

@Component({
    selector: 'z-invoice-payment-options',
    imports: [FormsModule, ReactiveFormsModule, ButtonModule],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ZInvoicePaymentOptionsComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: ZInvoicePaymentOptionsComponent
        }
    ],
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective //FormGroupDirective,
        }
    ],
    templateUrl: './z-invoice-payment-options.component.html',
    styleUrl: './z-invoice-payment-options.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ZInvoicePaymentOptionsComponent {
    dialogConfig: DynamicDialogConfig<InvoiceOptions> = inject(
        DynamicDialogConfig<InvoiceOptions>
    );
    private postInvoicesToAADESchema = inject(PostInvoicesToAADESchema);
    private posTerminalSchema = inject(POSTerminalGraphQLSchema);
    private invoicePaymentSchema = inject(InvoicePaymentGraphQLSchema);

    private http = inject(HttpClient);
    private store = inject(Store);

    laoderService = inject(LoaderService);

    /**
     * Get The active Invoice FormGroup based on Selected Tab
     * @returns The active Infoce Form Group
     */
    invoiceFormGroup(tabId?: 'services' | 'products' | 'none' | string) {
        debugger;

        const options = this.dialogConfig.data as InvoiceOptions;

        const selectedTabId =
            tabId ?? options?.selectedInvoiceTab?.() ?? 'services';

        switch (selectedTabId) {
            case 'services':
            case 'none':
                return options.invoiceCardTypeFormGroups?.[0];
        }

        return options.invoiceCardTypeFormGroups?.[1];
    }

    option(paymentType: number) {
        this.laoderService.showAwaitLoader();
        const options = this.dialogConfig.data as InvoiceOptions;
        this.store
            .dispatch(
                new POSTerminalGraphQLSchemaActions.Fetch(
                    POSTerminalTypeQuery.GQLQuery(),
                    undefined
                )
            )
            .pipe(
                concatMap((value) => {
                    debugger;
                    const posPOSTerminals =
                        this.store.selectSnapshot(
                            POSTerminalGraphQLSchemaSelectors.FetchSelector(
                                '',
                                ''
                            )
                        )?.data?.Fetch ?? [];

                    // Get the Terminal for Cardlink
                    const POSTerminal = posPOSTerminals.find(
                        (posTerminal) =>
                            posTerminal.Deleted != true &&
                            posTerminal.NSPId == '3'
                    );

                    // Get The First Payment. It does need to be type 7 or 5 or any other. We just need the first Payment (later we will allow user to select the payment he wants to).
                    // ΠΡΟΣΟΧΗ: Μοιραζόμαστε το ίδiο object με τα options με τις invoice-card, invoice-card-footer, z-invoice-payment και για αυτό πάιζει η this.invoiceFormGroup().
                    const invoicePaymentFormControl = // options.invoiceCardTypeFormGroups
                        this.invoiceFormGroup()?.controls?.Payments
                            ?.controls?.[0];

                    if (invoicePaymentFormControl?.value != undefined) {
                        // Bind The the first Cardlink Terminal to the payment
                        // 1.Reset the payment options. Set payment type to user selection
                        // 2.Reset POSTerminalId and Type07 proeprties to undefined
                        // 3. Set the fields POSTerminal and Type07 of the payment properly if the PaymentType == 7

                        invoicePaymentFormControl.controls.POSTerminalId?.setValue(
                            undefined,
                            { emitEvent: false }
                        );
                        invoicePaymentFormControl.controls.Type07?.setValue(
                            undefined,
                            { emitEvent: false }
                        );

                        if (paymentType == 7) {
                            invoicePaymentFormControl.controls.POSTerminalId?.setValue(
                                POSTerminal?._id,
                                { emitEvent: false }
                            );

                            invoicePaymentFormControl.controls.Type07?.setValue(
                                true,
                                { emitEvent: false }
                            );

                            invoicePaymentFormControl.controls.POSNspId?.setValue(
                                3, // 3 Cardlink
                                { emitEvent: false }
                            );
                        }

                        // Do this assigment last to force FormGroup to raise the ValueChanges event.
                        invoicePaymentFormControl.controls.Type?.setValue(
                            paymentType //paymentType == 7 ? 5 : paymentType
                        );

                        // Αν είμαστε σε νέα εγγραφή τιμολογίου που υπάρχει πληρωμή αλλά είναι μονο στη μνήμη (_id == undefined),
                        // τότε δεν χρειάζεται να ενημερώσεις τη βάση, οπότε επιστρέφεις στον caller σου.
                        if (invoicePaymentFormControl.value._id == undefined)
                            return of(undefined);

                        // Update the database
                        return this.store.dispatch(
                            new InvoicePaymentGraphQLSchemaActions.Upsert(
                                invoicePaymentFormControl.value as InvoicePaymentType,
                                undefined,
                                InvoicePaymentTypeQuery.GQLQuery()
                            )
                        );
                    }

                    return of(undefined);
                }),
                finalize(() => {
                    this.laoderService.dismissAwaitLoader();
                    debugger;
                    options.onPaymentOption?.(options, paymentType);
                    return of(undefined);
                })
            )
            .subscribe();
    }

    // option1(paymentType: number) {
    //     const options = this.dialogConfig.data as InvoiceOptions;

    //     //this.laoderService.showAwaitLoader();

    //     // If user's payment type selection is 'POS' then we have to bind the the selected (or the only one) POSTerminalId with the payment
    //     //
    //     // Get The POS Terminals of the User.
    //     debugger;
    //     this.store
    //         .dispatch(
    //             new POSTerminalGraphQLSchemaActions.Fetch(
    //                 POSTerminalTypeQuery.GQLQuery(),
    //                 undefined
    //             )
    //         )
    //         .pipe(
    //             concatMap((value) => {
    //                 debugger;
    //                 const posPOSTerminals =
    //                     this.store.selectSnapshot(
    //                         POSTerminalGraphQLSchemaSelectors.FetchSelector(
    //                             '',
    //                             ''
    //                         )
    //                     )?.data?.Fetch ?? [];

    //                 // Get the Terminal for Cardlink
    //                 const POSTerminal = posPOSTerminals.find(
    //                     (posTerminal) =>
    //                         posTerminal.Deleted != true &&
    //                         posTerminal.NSPId == '3'
    //                 );

    //                 // Get The First Payment. It does need to be type 7 or 5 or any other. We just need the first Payment (later we will allow user to select the payment he wants to)
    //                 const invoicePaymentFormControl =
    //                     options.invoiceCardTypeFormGroup?.controls?.Payments
    //                         ?.controls?.[0];

    //                 if (invoicePaymentFormControl?.value != undefined) {
    //                     // Bind The the first Cardlink Terminal to the payment
    //                     // 1.Reset the payment options. Set payment type to user selection
    //                     // 2.Reset POSTerminalId and Type07 proeprties to undefined
    //                     // 3. Set the fields POSTerminal and Type07 of the payment properly if the PaymentType == 7

    //                     invoicePaymentFormControl.controls.POSTerminalId?.setValue(
    //                         undefined,
    //                         { emitEvent: false }
    //                     );
    //                     invoicePaymentFormControl.controls.Type07?.setValue(
    //                         undefined,
    //                         { emitEvent: false }
    //                     );

    //                     if (paymentType == 7) {
    //                         invoicePaymentFormControl.controls.POSTerminalId?.setValue(
    //                             POSTerminal?._id,
    //                             { emitEvent: false }
    //                         );

    //                         invoicePaymentFormControl.controls.Type07?.setValue(
    //                             true,
    //                             { emitEvent: false }
    //                         );

    //                         invoicePaymentFormControl.controls.POSNspId?.setValue(
    //                             3, // 3 Cardlink
    //                             { emitEvent: false }
    //                         );
    //                     }

    //                     // Do this assigment last to force FormGroup to raise the ValueChanges event.
    //                     invoicePaymentFormControl.controls.Type?.setValue(
    //                         paymentType //paymentType == 7 ? 5 : paymentType
    //                     );

    //                     // Update the database
    //                     return this.store
    //                         .dispatch(
    //                             new InvoicePaymentGraphQLSchemaActions.Upsert(
    //                                 invoicePaymentFormControl.value as InvoicePaymentType,
    //                                 undefined,
    //                                 InvoicePaymentTypeQuery.GQLQuery()
    //                             )
    //                         )
    //                         .pipe(
    //                             concatMap((value) => {
    //                                 debugger;
    //                                 // Get the payment with the POSTerminalID (Just to ensure that the update is completed successfully)
    //                                 const payment = this.store.selectSnapshot(
    //                                     InvoicePaymentGraphQLSchemaSelectors.UpsertSelector(
    //                                         '',
    //                                         ''
    //                                     )
    //                                 );

    //                                 if (
    //                                     invoicePaymentFormControl.controls
    //                                         .Type07?.value != true
    //                                 ) {
    //                                     return of(undefined);
    //                                 }

    //                                 // Get the POS Signature for Old Invoice from Novus Provider
    //                                 return this.postInvoicesToAADESchema
    //                                     .AskSignatureForOldInvoice(
    //                                         options.invoiceCardTypeFormGroup?.getRawValue() as InvoiceType,
    //                                         ProviderSignatureTypeQuery.GQLQuery(
    //                                             {
    //                                                 SignatureMoreData:
    //                                                     ProviderSignatureMoreDataTypeQuery.GQLQuery(
    //                                                         {
    //                                                             Signatures:
    //                                                                 ProviderSignatureTypeQuery.GQLQuery()
    //                                                         }
    //                                                     )
    //                                             }
    //                                         )
    //                                     )
    //                                     .pipe(
    //                                         concatMap((response) => {
    //                                             debugger;
    //                                             const options = this
    //                                                 .dialogConfig
    //                                                 .data as InvoiceOptions;
    //                                             // options.invoiceCardTypeFormGroup?.controls?.Payments?.controls?.[0]?.controls?.Type?.setValue(
    //                                             //     paymentType
    //                                             // );
    //                                             const posPOSTerminals =
    //                                                 this.store.selectSnapshot(
    //                                                     POSTerminalGraphQLSchemaSelectors.FetchSelector(
    //                                                         '',
    //                                                         ''
    //                                                     )
    //                                                 )?.data?.Fetch ?? [];

    //                                             // Get the Terminal for Cardlink
    //                                             const POSTerminal =
    //                                                 posPOSTerminals.find(
    //                                                     (posTerminal) =>
    //                                                         posTerminal.Deleted !=
    //                                                             true &&
    //                                                         posTerminal.NSPId ==
    //                                                             '3'
    //                                                 );

    //                                             const totalGrossValue =
    //                                                 options
    //                                                     .invoiceCardTypeFormGroup
    //                                                     ?.controls?.Summaries
    //                                                     ?.controls?.[0]
    //                                                     ?.controls
    //                                                     ?.TotalGrossValue
    //                                                     ?.value ?? 0;

    //                                             const invoiceMARK =
    //                                                 options
    //                                                     .invoiceCardTypeFormGroup
    //                                                     ?.controls?.Response
    //                                                     ?.controls?.InvoiceMark
    //                                                     ?.value;

    //                                             const invoiceUid =
    //                                                 options
    //                                                     .invoiceCardTypeFormGroup
    //                                                     ?.controls?.Response
    //                                                     ?.controls?.InvoiceUid
    //                                                     ?.value;

    //                                             //const yyyyMMddHHmmSS
    //                                             const signatureCreatedDate =
    //                                                 new Date(
    //                                                     response?.data?.AskSignatureForOldInvoice?.CreatedDate?.toString() ??
    //                                                         new Date().toISOString()
    //                                                 );

    //                                             const twoDigits = (
    //                                                 value: number
    //                                             ) => {
    //                                                 const strValue =
    //                                                     value.toFixed(0);
    //                                                 if (strValue.length == 1)
    //                                                     return `0${strValue}`;
    //                                                 return strValue;
    //                                             };

    //                                             //'yyyyMMddHHmmSS'
    //                                             const dateTimeProviderSignature = `${signatureCreatedDate.getFullYear()}${twoDigits(
    //                                                 signatureCreatedDate.getMonth()
    //                                             )}${twoDigits(signatureCreatedDate.getDate())}${twoDigits(signatureCreatedDate.getHours())}${twoDigits(signatureCreatedDate.getMinutes())}${twoDigits(signatureCreatedDate.getSeconds())}`;

    //                                             const signature =
    //                                                 this.hex2Base64(
    //                                                     response?.data
    //                                                         ?.AskSignatureForOldInvoice
    //                                                         ?.Token ?? ''
    //                                                 );

    //                                             const data = (
    //                                                 response?.data
    //                                                     ?.AskSignatureForOldInvoice
    //                                                     ?.Data ?? ''
    //                                             ).split(';');

    //                                             // https://www.npmjs.com/package/uuid
    //                                             const uniqueTxnId =
    //                                                 uuidv4().replaceAll(
    //                                                     '-',
    //                                                     ''
    //                                                 );

    //                                             debugger;
    //                                             const posData = {
    //                                                 serviceData: {
    //                                                     host: POSTerminal?.IP, // 'virtualpos.services.novidea.gr',
    //                                                     port: POSTerminal?.Port, // '4000',
    //                                                     ecrid: POSTerminal?.TerminalId // '80531138'
    //                                                 },
    //                                                 transactionData: {
    //                                                     firstByteOriginalTrans:
    //                                                         '0',
    //                                                     uniqueTxnId:
    //                                                         uniqueTxnId, //'2e878689f6cf4f50faf99c6e4e24b827', <---
    //                                                     uniqueIntegratorId:
    //                                                         POSTerminal?.ECR2EFTWebServerIP ==
    //                                                             undefined ||
    //                                                         POSTerminal?.ECR2EFTWebServerIP ==
    //                                                             'http://localhost:8080'
    //                                                             ? '8ae379dfd80a40fcb604ce772c3f5440'
    //                                                             : null, // TODO: Αυτό να φύγει στη παραγωγή!!!! <---
    //                                                     amount: totalGrossValue.toFixed(
    //                                                         2
    //                                                     ),
    //                                                     signature: signature,
    //                                                     //'MEQCIHsYkPbv6lpfFKAXY6tMKuY8NOzZD9Aj4q187SP8wdlNAiBd2oV5/zbmxtyyRa0jU48CavA1P0PMsPurGoQEoKGfRA==',
    //                                                     // https://www.aade.gr/mydata/adeiodotimena-logismika-parohon-ilektronikis-timologisis
    //                                                     // Το 005 είναι ο κωδικός που έχει η NOVUS CONCEPTUS Ο.Ε
    //                                                     providersId: '5', //`${POSTerminal?.NSPId}`, // '1122', // add 500 for production validation <---
    //                                                     uniqueEntryNumber:
    //                                                         data[1], //invoiceMARK, //'400001952023970',
    //                                                     uid: data[0], // invoiceUid, // '',
    //                                                     dateTimeProviderSignature:
    //                                                         data[2], //dateTimeProviderSignature,
    //                                                     amountPayable: data[5],
    //                                                     netValue: data[3], // '0', //'',
    //                                                     vatValue: data[4], //'0', //'',
    //                                                     totalValue: data[6],
    //                                                     eftTerminalId: data[7], //POSTerminal?.TerminalId, //'80531138',
    //                                                     posId: data[7], //POSTerminal?.TerminalId, //'80531138',
    //                                                     ecrId: data[7] //POSTerminal?.TerminalId //'80531138'
    //                                                 }
    //                                             };

    //                                             // const postData2 = {
    //                                             //     serviceData: {
    //                                             //         host: 'virtualpos.services.novidea.gr',
    //                                             //         port: '4000',
    //                                             //         ecrid: '80531138'
    //                                             //     },
    //                                             //     transactionData: {
    //                                             //         firstByteOriginalTrans:
    //                                             //             '0',
    //                                             //         uniqueTxnId:
    //                                             //             '3320816fcaff41aa022a888d5732c258',
    //                                             //         uniqueIntegratorId:
    //                                             //             '8ae379dfd80a40fcb604ce772c3f5440',
    //                                             //         amount: '1.00'
    //                                             //     }
    //                                             // };
    //                                             console.debug(
    //                                                 'Sending payment to POS:',
    //                                                 {
    //                                                     Terminal: POSTerminal,
    //                                                     posData: posData
    //                                                 }
    //                                             );

    //                                             return this.http
    //                                                 .post(
    //                                                     `${
    //                                                         POSTerminal?.ECR2EFTWebServerIP ??
    //                                                         'http://localhost:8080'
    //                                                     }/sale`,
    //                                                     posData
    //                                                 )
    //                                                 .pipe(
    //                                                     concatMap((value) => {
    //                                                         console.debug(
    //                                                             'response from POS',
    //                                                             {
    //                                                                 POSResponse:
    //                                                                     value,

    //                                                                 POSPayload:
    //                                                                     posData,
    //                                                                 AskSignatureForOldInvoice:
    //                                                                     response
    //                                                             }
    //                                                         );

    //                                                         // this.postInvoicesToAADESchema.CompletionAskSignatureForOldInvoice()
    //                                                         debugger;
    //                                                         return of(value);
    //                                                     })
    //                                                 );
    //                                             // options.onPaymentOption?.(
    //                                             //     options,
    //                                             //     paymentType
    //                                             // );
    //                                             // return of(response);
    //                                         })
    //                                     );
    //                             })
    //                         );
    //                 } else {
    //                     alert('No Payment found for the selected Invoice');
    //                 }

    //                 return of(undefined);
    //             }),
    //             finalize(() => {
    //                 //this.laoderService.dismissAwaitLoader();
    //                 options.onPaymentOption?.(options, paymentType);
    //                 return of(undefined);
    //             })
    //         )
    //         .subscribe((value) => {
    //             debugger;
    //         });
    //     //this.store.dispatch(new )

    //     // timer(600).subscribe(() => {
    //     //     debugger;
    //     //     if (options.invoiceCardTypeFormGroup) {
    //     //         alert(
    //     //             'Getting Invoice Info from Provider for use with Cardlink POS'
    //     //         );
    //     //     }

    //     //     this.laoderService.dismissAwaitLoader();
    //     // });
    // }

    /*

      import binascii
      import base64
      # from pyasn1.codec.ber.decoder import decoder # Example of a possible ASN.1 library.  This is not a built-in Python library.
      # from pyasn1.type.univ import Sequence, Integer # Example of ASN.1 types.  This is not a built-in Python library.

      # Assume 'hex_signature' is your hexadecimal representation of the signature
      hex_signature = "3045022100d8c67a39838617835a107696d5585639a6c708b1f3f429916193148e2656a37002200a5f46c713ba3770888ca799106778a30339360f273f635f32850f44682b7d0e"

      # 1. Decode Hex to Bytes
      byte_signature = binascii.unhexlify(hex_signature)

      # 2. (Optional) Parse ASN.1 (Example using pyasn1 - replace with actual parsing logic)
      # decoded_data, remaining = decoder.decode(byte_signature, asn1Spec=Sequence())
      # r = decoded_data[0].asOctets()
      # s = decoded_data[1].asOctets()
      # byte_signature = r + s  # Reconstruct the byte array from r and s values

      # 3. Encode Bytes to Base64
      base64_signature = base64.b64encode(byte_signature).decode('utf-8')

    */
    // https://support.cardlink.gr/support/discussions/topics/7000043307
    // https://support.cardlink.gr/support/discussions/topics/7000043398
    // https://stackoverflow.com/questions/1459006/is-there-a-c-sharp-equivalent-to-pythons-unhexlify
    hex2Binary(hexValue: string): string {
        let binaryVal: string[] = [];
        for (let i = 0; i < hexValue.length; i++) {
            const byteString = hexValue.substring(i, i + 1);
            const b = parseInt(byteString, 16);
            binaryVal.push(b.toString(2).padStart(4, '0'));
        }
        return binaryVal.join('');
    }

    hex2Base64(hexValue: string): string {
        if (hexValue.length % 2 !== 0) {
            hexValue = '0' + hexValue;
        }

        const bytes = new Uint8Array(hexValue.length / 2);
        for (let i = 0; i < bytes.length; i++) {
            const byteString = hexValue.substring(2 * i, 2 * i + 2);
            bytes[i] = parseInt(byteString, 16);
        }

        // Convert bytes to base64
        let binary = '';
        bytes.forEach((b) => (binary += String.fromCharCode(b)));
        return btoa(binary); // btoa is available in browsers; use Buffer in Node.js
    }
}
